// The application no longer uses a service worker. This module only removes
// the Workbox service worker that the old Create React App build registered,
// together with the caches it created.
// public/service-worker.js is a self-destroying worker that does the same
// for browsers that only update the worker without loading the new bundle.

export async function unregister() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
    if (typeof window !== 'undefined' && 'caches' in window) {
      const cacheNames = await window.caches.keys();
      await Promise.all(cacheNames.map(cacheName => window.caches.delete(cacheName)));
    }
  } catch (error) {
    console.error('Failed to unregister the legacy service worker', error);
  }
}

export default unregister;
